// 運賃お伺い書 集計（中身/TMS・純関数）。trips → 相手先×月×区分（請求/支払）の集計＋明細。
// 出所: build_oki.py / oki_data.json（sub=運賃課税対象, toll=立替通行料(非課税), tax=sub×10%, total=sub+tax+toll）。
// 相手先の正式名称・コード＋枝番・登録番号(T) は取込時に名寄せ済み（customerFormal/partnerFormal/partnerTnum）。
const TAX_RATE = 0.10
const yen = (n) => Math.round(Number(n) || 0)

// trips配列 → { [YYYY-MM]: { seikyu:[相手先...], shiharai:[相手先...] } }
export function buildSheets(trips) {
  const acc = {} // month -> {seikyu:Map, shiharai:Map}
  const bucket = (m) => (acc[m] || (acc[m] = { seikyu: new Map(), shiharai: new Map() }))
  const add = (map, key, meta, run) => {
    let g = map.get(key)
    // key は請求書ビューが得意先を指すのに使う（#/invoice?m=&k=）。集計には効かない
    if (!g) { g = { key, ...meta, n: 0, sub: 0, toll: 0, runs: [] }; map.set(key, g) }
    g.n++; g.sub += run.amt; g.toll += run.toll; g.runs.push(run)
  }
  for (const t of trips) {
    const m = t.month || (t.date || '').slice(0, 7)
    if (!m || m.length < 7) continue
    const B = bucket(m)
    const run = {
      unko: t.date, oroshi: t.unloadDate || t.date, a: t.origin || '', b: t.dest || '',
      kb: t.vehicleClass || '', hin: t.item || '',
      // 請求書（得意先向け帳票）の明細列。車番・備考・割増は集計には効かず、紙にだけ出る
      // （2026-08-28。既存の消費者＝billing/chargesheet/snapshotLines は見ないので影響なし）
      sha: t.vehicleId || '', biko: t.memo || '', wari: yen(t.surcharge),
    }
    // 請求(seikyu): 得意先ごと（運賃＝課税, 請通行料＝立替）
    const cname = t.customerFormal || t.customerName
    if (cname) {
      const key = (t.customerCode != null) ? `c${t.customerCode}-${t.customerBranchNo ?? ''}` : `n:${cname}`
      add(B.seikyu, key, { name: cname, code: t.customerCode ?? null, branchNo: t.customerBranchNo ?? null, tnum: '' },
        { ...run, amt: yen(t.fare), toll: yen(t.tollBill != null ? t.tollBill : t.tollCost) })
    }
    // 支払(shiharai): 協力会社ごと（傭車費＝課税, 支通行料＝立替, 相手のT番号）
    const pname = t.partnerFormal || t.partnerName
    if (t.kind === 'charter' && pname) {
      const key = (t.partnerCode != null) ? `p${t.partnerCode}-${t.partnerBranchNo ?? ''}` : `n:${pname}`
      add(B.shiharai, key, { name: pname, code: t.partnerCode ?? null, branchNo: t.partnerBranchNo ?? null, tnum: t.partnerTnum || '' },
        { ...run, amt: yen(t.charterCost), toll: yen(t.tollPay) })
    }
  }
  const out = {}
  for (const m of Object.keys(acc)) {
    out[m] = {}
    for (const kind of ['seikyu', 'shiharai']) {
      out[m][kind] = [...acc[m][kind].values()].map((g) => {
        const tax = Math.round(g.sub * TAX_RATE)
        return { ...g, tax, total: g.sub + tax + g.toll }
      }).sort((a, b) => b.total - a.total)
    }
  }
  return out
}

export function listMonths(sheets) { return Object.keys(sheets).sort() }

// 月×区分の合計（KPI用）。
export function totals(sheets, month, kind) {
  const arr = (sheets[month] && sheets[month][kind]) || []
  return arr.reduce((s, g) => ({ n: s.n + g.n, sub: s.sub + g.sub, tax: s.tax + g.tax, toll: s.toll + g.toll, total: s.total + g.total, parties: s.parties + 1 }),
    { n: 0, sub: 0, tax: 0, toll: 0, total: 0, parties: 0 })
}

/**
 * 送付状態のトグル。手動送付（リンクをコピー等）のあと、発行を「送付済」にする／戻すための遷移を返す。
 * 送付の前後にいる発行だけ操作させる。confirmed/settled/void で戻せると状態が逆行するため null を返す。
 * @param {string} status 現在の status（issued / sent / confirmed / settled / void）
 * @param {Date} now 送付日時（テスト用に注入可能）
 * @param {string|null} sentBy 操作したユーザー（ログイン中のメール）
 * @returns {{label:string, patch:object}|null} ボタンを出さない場合は null
 */
export function nextSendState(status, now = new Date(), sentBy = null) {
  if (status === 'issued') return { label: '送付済にする', patch: { status: 'sent', sentAt: now.toISOString(), sentBy } }
  if (status === 'sent') return { label: '未送付に戻す', patch: { status: 'issued', sentAt: null, sentBy: null } }
  return null
}
